const encodeField = (field: unknown) => {
  let encodedField = String(field).trim();

  encodedField = encodedField.replaceAll('"', '""');

  return `"${encodedField}"`;
};

const separator = ',';

/**
 * Encode an array of fields into a CSV string
 * F.e. encodeCSVFields(['a', 'b', 'c']) => '"a","b","c"'
 * @param fields
 * @param customSeparator
 */
export const encodeCSVFields = (
  fields: unknown[],
  customSeparator: string = separator,
): string => {
  return fields.map(encodeField).join(customSeparator);
};
